import React from 'react';
import injectSheet from 'react-jss';
import { Subscribe } from 'unstated';
import PropTypes from 'prop-types';
import {
  Card, CardBody, CardFooter, Button, CardImg,
} from 'reactstrap';
import JamParentSelectContainer from '../containers/JamParentSelectContainer';

const styles = {
  cardContainer: {
    marginRight: '2rem',
    marginBottom: '2rem',
    // boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    position: 'absolute',
    top: 0,
    right: '-2rem',
    cursor: 'default',
  },
  card: {
    minWidth: '41.25rem',
    maxWidth: '41.25rem',
    height: '100vh',
    borderRadius: 0,
  },
  cardHeaderContainer: {
    display: 'flex',
  },
  iconWrapper: {
    width: '5rem',
    height: '6rem',
    fontSize: '5rem',
  },
  textHeaderWrapper: {
    marginLeft: '0.5rem',
    marginTop: '0.5rem',
  },
  label: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    fontWeight: 'bold',
    marginBottom: '0.3rem',
    marginTop: '0.4rem',
  },
  blurb: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#656565',
    lineHeight: '1.313rem',
  },
  footer: {
    background: '#FFF',
    boxShadow: '0px -2px 7px -2px rgba(3, 3, 3, 0.18)',
    WebkitBoxShadow: '0px -2px 7px -2px rgba(3, 3, 3, 0.18)',
    MozBoxShadow: '0px -2px 7px -2px rgba(3, 3, 3, 0.18)',
  },
  btnWrapper: {
    display: 'inline-block',
    'float': 'right',
    marginLeft: '0.5rem',
  },
  confirmBtn: {
    background: '#34A5DA',
    fontFamily: 'Lato, Arial',
    fontSize: '1rem',
    color: '#FFFFFE',
    textAlign: 'center',
    width: '16.75rem',
    border: 0,
    '&:hover, :active': {
      background: '#34A5DA !important',
      color: '#FFFFFE !important',
      border: '0 !important',
    },
    '&:focus': {
      boxShadow: 'none',
    },
  },
  cancelBtn: {
    background: 'transparent',
    fontFamily: 'Lato, Arial',
    fontSize: '1rem',
    color: '#979797',
    textAlign: 'center',
    border: 0,
    '&:hover, :active': {
      background: 'transparent !important',
      color: '#979797 !important',
    },
    '&:focus': {
      boxShadow: 'none !important',
      background: 'transparent',
      color: '#979797',
    },
  },
  image: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    objectFit: 'cover',
  },
  cardImageWrapper: {
    height: '6rem',
    width: '6rem',
  },
};

const ParentJamDetails = (props) => {
  const {
    classes, icon, label, blurbLabel, title, blurb, image, type,
  } = props;
  return (
    <Subscribe to={[JamParentSelectContainer]}>
      { jamParent => (
        <div className={classes.cardContainer}>
          <Card className={classes.card}>
            <CardBody className={classes.cardBody}>
              <div className={classes.cardHeaderContainer}>
                {/* <div className={classes.iconWrapper}>
                  <i className={icon} />
                </div> */}

                <div className={image ? classes.cardImageWrapper : classes.iconWrapper}>
                  {image ? <CardImg top className={classes.image} src={image} />
                    : <i className={icon} />
                  }
                </div>


                <div className={classes.textHeaderWrapper}>
                  <div className={classes.label}>{label}</div>
                  <div className={classes.blurb}>{title}</div>
                </div>
              </div>
              <div className={classes.BodyContainer}>
                <div className={classes.label}>{blurbLabel}</div>
                <div className={classes.blurb}>{blurb}</div>
              </div>
            </CardBody>
            <CardFooter className={classes.footer}>
              <div>
                <span className={classes.btnWrapper}>
                  <Button color="primary" className={classes.confirmBtn} onClick={jamParent.handleCardSelection}>{`Pick this ${type}`}</Button>
                </span>
                <span className={classes.btnWrapper}>
                  <Button className={classes.cancelBtn} onClick={jamParent.onDrawerClose}>
                    Cancel
                  </Button>
                </span>
              </div>
            </CardFooter>
          </Card>
        </div>
      )}
    </Subscribe>
  );
};

ParentJamDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  blurb: PropTypes.string.isRequired,
  blurbLabel: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default injectSheet(styles)(ParentJamDetails);



// WEBPACK FOOTER //
// ./src/components/ParentJamDetails.js